module.exports = __webpack_public_path__ + "static/media/foto_vehiculo_dorso@2x.b765b2f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/foto_vehiculo_dorso@2x.jpg
// module id = 644
// module chunks = 0